import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, X } from "lucide-react";

export function MultiEntryField({ label, entries, onChange, placeholder, icon: Icon, testIdPrefix }) {
  const addEntry = () => onChange([...entries, ""]);
  const removeEntry = (idx) => onChange(entries.filter((_, i) => i !== idx));
  const updateEntry = (idx, val) => onChange(entries.map((e, i) => i === idx ? val : e));

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-6 text-xs text-primary px-2"
          data-testid={`${testIdPrefix}-add-btn`}
          onClick={addEntry}
        >
          <Plus className="w-3 h-3 mr-1" /> Add
        </Button>
      </div>
      {entries.length === 0 && (
        <p className="text-xs text-muted-foreground/50 py-1">None added</p>
      )}
      <div className="space-y-1.5">
        {entries.map((entry, idx) => (
          // Key by index only — including the value would remount the input
          // (and drop focus) on every keystroke.
          <div key={`${testIdPrefix}-${idx}`} className="flex items-center gap-1.5">
            {Icon && <Icon className="w-3.5 h-3.5 text-muted-foreground shrink-0" />}
            <Input
              data-testid={`${testIdPrefix}-input-${idx}`}
              value={entry}
              onChange={e => updateEntry(idx, e.target.value)}
              placeholder={placeholder}
              className="h-8 text-sm bg-secondary/30 border-border flex-1"
            />
            <button
              data-testid={`${testIdPrefix}-remove-${idx}`}
              onClick={() => removeEntry(idx)}
              className="text-muted-foreground hover:text-red-400 shrink-0 p-1"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
